<template>
  <div class="map-bar-container">
    <div class="shuax" @click="Refresh"></div>
    <div class="chongz" @click="Reset"></div>
    <div class="shez">
      <div class="shez1">{{ time }}</div>
      <div :class="{ on: 1 == size }">
        <div class="shez2" @click="xiugai(0)">关闭</div>
        <div class="shez2" @click="xiugai(30000)">每30秒</div>
        <div class="shez2" @click="xiugai(300000)">每5分钟</div>
        <div class="shez2" @click="xiugai(600000)">每10 分钟</div>
      </div>
    </div>
    <div class="search">
      <el-select
        v-model="searchInfo.companyId"
        style="margin-right: 10px"
        placeholder="请选择公司"
        v-if="$store.state.home.RoleId == 1"
      >
        <el-option
          v-for="item in companyList"
          :key="item.company_id"
          :label="item.company_name"
          :value="item.company_id"
        >
        </el-option>
      </el-select>
      <el-input
        placeholder="请输入车牌号或车架号"
        v-model="searchInfo.licenseNum"
        style="width: 200px; margin-top: 10px"
      ></el-input>
    </div>
    <div class="search">
      <el-button
        type="primary"
        style="margin-top: 10px; margin-left: 10px"
        @click="searchAction"
        >搜索</el-button
      >
    </div>
    <div
      style="margin-top: 10px; margin-left: 10px"
      v-show="searchInfo.licenseNum"
      v-hasPermi="['综合监视', '轨迹查询']"
    >
      <el-date-picker
        v-model="date"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd HH"
      >
      </el-date-picker>
      <el-button
        type="primary"
        style="margin-left: 10px"
        :disabled="!date || date.length === 0"
        @click="getVT()"
        >轨迹查询</el-button
      >
      <el-button
        type="danger"
        @click="clearVT()"
        v-hasPermi="['综合监视', '清除轨迹']"
        >清除轨迹</el-button
      >
    </div>
  </div>
</template>

<script>
import { getCompanyList } from '@/api/home'
export default {
  data () {
    return {
      size: 1,
      time: "自动刷新设置",
      date: [],
      companyList: [],
      searchInfo: {
        companyId: '',
        licenseNum: '',
      }
    };
  },
  mounted () {
    if (this.$route.params.num) {
      this.searchInfo.licenseNum = this.$route.params.num
      this.searchAction()
    }
    getCompanyList().then(da => {
      this.companyList = da.data
    })
  },
  methods: {
    itemClick (item) {
      let flag = this.selected.indexOf(item.title);
      if (flag >= 0) {
        this.selected.splice(flag, 1);
        return;
      }
      this.selected.push(item.title);
    },
    Reset () {
      if (this.size == 1) {
        this.size = 2;
      } else {
        this.size = 1;
      }
    },
    Refresh () {
      this.Emit.$emit("refreshData");
    },
    xiugai (val) {
      if (val == 30000) {
        this.time = "每30秒";
        this.Emit.$emit("setupTime", { value: val });
      } else if (val == 300000) {
        this.time = "每5分钟";
        this.Emit.$emit("setupTime", { value: val });
      } else if (val == 600000) {
        this.time = "每10分钟";
        this.Emit.$emit("setupTime", { value: val });
      } else {
        this.time = "关闭";
        this.Emit.$emit("closeInterval");
      }
      this.size = 1;
    },
    searchAction () {
      // this.Emit.$emit("searchAction", { value: this.searchValue });
      this.$emit("searchAction", this.searchInfo);
    },
    //查询轨迹
    getVT () {
      let params = {
        licenseNum: this.searchInfo.licenseNum,
        beginTime: this.date[0],
        endTime: this.date[1]
      }
      this.$emit('searchVT', params)
    },
    clearVT () {
      this.$emit('clearVT')
    }
  }
};
</script>

<style lang="less" scoped>
.map-bar-container {
  position: absolute;
  top: 0px;
  // width: 600px;
  height: 56px;
  // background-color: red;
  z-index: 10;
  display: flex;
  .shuax {
    width: 56px;
    height: 56px;
    // background-color: green;
    background: url("../../../../assets/images/shuax.png") no-repeat;
    // background-size: 70%;
    background-position: 50%;
    margin-left: 20px;
    cursor: pointer;
  }
  .chongz {
    width: 56px;
    height: 56px;
    // background-color: green;
    background: url("../../../../assets/images/shez.png") no-repeat;
    // background-size: 80%;
    background-position: 50%;
    margin: 0 20px;
    cursor: pointer;
  }
  .search {
    // float: right;
    // width: 200px;
    height: 56px;
  }
  .shez {
    width: 190px;
    // height: 1000px;
    border: 1px solid rgb(1, 37, 52);
    .shez1 {
      width: 100%;
      height: 100%;
      text-align: center;
      color: rgb(164, 165, 168);
      line-height: 56px;
      font-size: 20px;
    }
    .shez2 {
      width: 100%;
      height: 40px;
      margin-left: 20px;
      color: white;
      line-height: 56px;
      font-size: 18px;
      cursor: pointer;
    }
    .shez2:hover {
      color: rgb(54, 142, 195);
    }
    .on {
      display: none;
    }
  }
}
</style>
